import React, { Component } from "react";
import Footer from "../home/Footer";
import Header from "../home/Header";
import "./NonProfits.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
class NonProfits extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Header />
        <section
          id="more-services"
          className="more-services"
          style={{ padding: "60px 150px" }}
        >
          <div className="container">
            <div className="row">
              <div className="section-title ">
                <h2>How it works</h2>
              </div>
              <div className="col-md-12">
                <ul className="progressbar p-0">
                  <li className="active"></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 d-flex align-items-stretch">
                <div className="card" data-aos="fade-up" data-aos-delay={100}>
                  <div className="card-body">
                    <p>
                      Your donors and others text your custom keyword to a
                      10-digit number assigned to your organization.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex align-items-stretch">
                <div className="card" data-aos="fade-up" data-aos-delay={100}>
                  <div className="card-body">
                    <p>
                      Our system responds with a friendly text experience that
                      guides the user to make a donation or directs them to the
                      information they need.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 d-flex align-items-stretch">
                <div className="card" data-aos="fade-up" data-aos-delay={100}>
                  <div className="card-body">
                    <p>
                      At any time, you can send text reminders, invites and
                      important info to your full opt-in list or to specific
                      sub-groups.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="row"
              style={{ marginTop: "6em", textAlign: "center" }}
              id="SimplifyBox"
            >
              <h3 style={{ marginBottom: "1em" }}>
                <b>
                  Simplify the way you raise funds and connect with your donors!
                </b>
              </h3>
              <div className="col-md-6 d-flex align-items-stretch">
                <div
                  className="card1"
                  data-aos="fade-up"
                  data-aos-delay={100}
                  id="more-services-card"
                >
                  <div className="card-body">
                    <h5 className="card-title">BOOST READ RATES</h5>
                    <p>
                      If you’re not already offering text messaging as a
                      donation and communication option for your supporters, now
                      is the time! SMS messaging read rates exceed 95%.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex align-items-stretch">
                <div
                  className="card2"
                  data-aos="fade-up"
                  data-aos-delay={100}
                  id="more-services-card"
                >
                  <div className="card-body">
                    <h5 className="card-title">REDUCE TIME SPENT</h5>
                    <p>
                      With GivBee’s simple-to-use you can launch campaigns, send
                      texts and grow your opt-in list with ease. Opt-outs are
                      handled automatically.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: "2em" }}>
                <div className="col-md-6 d-flex align-items-stretch">
                  <div
                    className="card3"
                    data-aos="fade-up"
                    data-aos-delay={100}
                    id="more-services-card"
                  >
                    <div className="card-body">
                      <h5 className="card-title">
                        CONNECT TO YOUR EXISTING SYSTEM
                      </h5>
                      <p>
                        GivBee’s built-in integrations will exchange data with
                        some of the most-popular donation management platforms
                        available — saving you hours and hours of added work.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex align-items-stretch">
                  <div
                    className="card4"
                    data-aos="fade-up"
                    data-aos-delay={100}
                    id="more-services-card"
                  >
                    <div className="card-body">
                      <h5 className="card-title">BUILD RAPPORT</h5>
                      <p>
                        GivBee’s system is designed for much more than just
                        fundraising. Use it to create your opt-in list and to
                        then send reminders, event promotions, alerts, thank
                        yous and more!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section id="pricing" className="pricing ">
              <div className="container">
                <div className="section-title ">
                  {/* <h2>Pricing</h2> */}
                  <div className="row" style={{ margin: "1em" }}>
                    <div className="col-md-12" id="pricingItem">
                      <h3 className="bold">Key features include:</h3>
                      <p>~ Text-to-give</p>
                      <p>~ Text-to-pledge (with real-time meter)</p>
                      <p>~ Promotional & marketing texting</p>
                      <p>~ Message scheduling</p>
                      <p>~ Support for link sharing (eg. donation pages)</p>
                      <p>~ PayPal integration (optional)</p>
                      <p>~ Data capture & real-time reporting</p>
                      <p>~ Free training & tech support</p>
                    </div>
                    <div className="col-md-12" id="pricingItem">
                      <h3 className="bold" style={{ marginTop: "1em" }}>
                        Integrated with popular donor management platforms
                      </h3>
                      <h6 id="pricingItem">DONORPERFECT</h6>
                      <h6 id="pricingItem">NEONCRM</h6>
                      <h6 id="pricingItem">BLACKBAUD RENXT & CSM</h6>
                      <h6 id="pricingItem">BLUESKY</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="section-title ">
                    <h2>
                      <b>Multiple plans to choose from</b>
                    </h2>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div
                      className="box recommended"
                      data-aos="zoom-in-right"
                      data-aos-delay={200}
                    >
                      <h4>
                        <sup>$</sup>89<span> / month</span>
                      </h4>
                      <ul>
                        <li>1,000 SMS messages/month</li>
                        <li>Unlimited keywords</li>
                        <li>Nulla at volutpat dola</li>
                        <li>Overages fee: $0.05/text</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          ENTRY PLAN
                        </a>
                      </div>
                      <h3>
                        <b>MOST POPULAR</b>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
                    <div
                      className="box"
                      data-aos="zoom-in"
                      data-aos-delay={100}
                    >
                      <h3>Business</h3>
                      <h4>
                        <sup>$</sup>149<span> / month</span>
                      </h4>
                      <ul>
                        <li>2,000 SMS messages/month</li>
                        <li>Unlimited keywords</li>
                        <li>Overages fee: $0.045/text</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          STANDARD PLAN
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                    <div
                      className="box"
                      data-aos="zoom-in-left"
                      data-aos-delay={200}
                    >
                      <h3>Developer</h3>
                      <h4>
                        <sup>$</sup>209<span> / month</span>
                      </h4>
                      <ul>
                        <li>4,000 SMS messages/month</li>
                        <li>Unlimited keywords</li>
                        <li>Overages fee: $0.04/text</li>
                      </ul>
                      <div className="btn-wrap">
                        <a href="/signup" className="btn-buy">
                          PREMIER PLAN
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="testimonials" className="testimonials section-bg">
              <div className="container">
                <div className="section-title" data-aos="fade-up">
                  <h2>Testimonials</h2>
                </div>
                <Carousel autoPlay>
                  <div>
                    <div className="swiper-slide">
                      <div className="testimonial-wrap">
                        <div className="testimonial-item">
                          <p>
                            <i className="bx bxs-quote-alt-left quote-icon-left" />
                            “Initially I was concerned about the tech part
                            because I’m not techie. But it was very easy-to-use
                            and contributed to the overall success of the event.
                            I think it’s a great service…I’m really happy.”
                            <i className="bx bxs-quote-alt-right quote-icon-right" />
                          </p>
                          <h3 id="pricingItem">
                            <b>Leslie McGarry</b>
                          </h3>
                          <h4 id="pricingItem">Development Director</h4>
                          <h6 id="pricingItem">Serra Center</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="swiper-slide">
                      <div className="testimonial-wrap">
                        <div className="testimonial-item">
                          <p>
                            <i className="bx bxs-quote-alt-left quote-icon-left" />
                            “The GivBee text system allowed us the ability to
                            not only raise money at our events but give that
                            instant gratification to donors by seeing how much
                            we raised. It is a great tool that every nonprofit
                            should use. We’ve also incorporated it into our
                            monthly messaging for event reminders, success
                            stories, highlighting our mission and ticket sales.”
                            <i className="bx bxs-quote-alt-right quote-icon-right" />
                          </p>
                          <h3 id="pricingItem">
                            <b>Brett Diaz</b>
                          </h3>
                          <h4 id="pricingItem">Marketing Director</h4>
                          <h6 id="pricingItem">Goodman JFS</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="swiper-slide">
                      <div className="testimonial-wrap">
                        <div className="testimonial-item">
                          <p>
                            <i className="bx bxs-quote-alt-left quote-icon-left" />
                            “The buzz in the room was amazing – as donations
                            were being made via the text system, the people in
                            the room started clapping and the thermometer total
                            went up and up. The energy that the texting
                            thermometer creates is infectious. In a span of
                            about five minutes, donations increased by 38%. At
                            first, I thought it was a mistake because the amount
                            shot up so fast.”
                            <i className="bx bxs-quote-alt-right quote-icon-right" />
                          </p>
                          <h3 id="pricingItem">
                            <b>Anne Rose</b>
                          </h3>
                          <h4 id="pricingItem">
                            Director of Development and Communications
                          </h4>
                          <h6 id="pricingItem">LINC, Inc.</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </Carousel>
              </div>
            </section>
          </div>
        </section>
        <Footer />
      </>
    );
  }
}

export default NonProfits;
